import React from 'react';
import styles from './StateAvailablePanel.module.css';
import { stateZipCodes } from '../utils/StateZipCodes';

const StateAvailabilityPanel = ({ stateData }) => {
    if (!stateData || stateData.length === 0) {
        return (
            <div className={styles.panelContainer}>
                <h4 className={styles.panelHeading}>Available Store Locations</h4>
                <div className={styles.noDataMessage}>
                    No state data available
                </div>
            </div>
        );
    }

    const safeStateData = Array.isArray(stateData) ? stateData : [];

    if (safeStateData.length === 0) {
        return (
            <div className={styles.panelContainer}>
                <h4 className={styles.panelHeading}>Available Store Locations</h4>
                <div className={styles.noDataMessage}>
                    No state data available
                </div>
            </div>
        );
    }
    
    const availableStates = safeStateData.filter(state => state && state.available);
    availableStates.sort((a, b) => a.stateName.localeCompare(b.stateName));
    const hasRetailerMetadata = availableStates.some((state) =>
        Object.prototype.hasOwnProperty.call(state, 'hasBestBuy') ||
        Object.prototype.hasOwnProperty.call(state, 'hasMicroCenter')
    );

    if (availableStates.length === 0) {
        return (
            <div className={styles.panelContainer}>
                <h4 className={styles.panelHeading}>Available Store Locations</h4>
                <div className={styles.noDataMessage}>
                    No stores currently have this item in stock
                </div>
            </div>
        );
    }

    return (
        <div className={styles.panelContainer}>
            <h4 className={styles.panelHeading}>Available Store Locations</h4>
            
            <div className={styles.statesContainer}>
                <div className={styles.headerRow}>
                    <div className={styles.cell}>State</div>
                    <div className={styles.cell}>Zip Code</div>
                    {hasRetailerMetadata && <div className={styles.cell}>Retailer</div>}
                </div>
                
                {availableStates.map((state) => (
                    <div 
                        key={`${state.stateCode || state.stateName}-${state.zipCode || ''}`}
                        className={styles.stateRow}
                    >
                        <div className={styles.cell}>{state.stateName}</div>
                        <div className={styles.cell}>{state.zipCode || stateZipCodes[state.stateName] || '—'}</div>
                        {hasRetailerMetadata && (
                            <div className={styles.cell}>
                                <div className={styles.retailerLogos}>
                                    {state.hasBestBuy && (
                                        <img
                                            src="/images/pics/Best_Buy_Logo.svg.png"
                                            alt="Best Buy"
                                            className={styles.retailerLogo}
                                        />
                                    )}
                                    {state.hasMicroCenter && (
                                        <img
                                            src="/images/pics/microcenter-logo.jpeg"
                                            alt="Micro Center"
                                            className={styles.retailerLogo}
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default StateAvailabilityPanel;
